'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRedux = require('react-redux');

var _profile = require('redux/modules/profile');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// methods used for redux

var DatePicker = require('react-bootstrap-date-picker');
var ChildProfile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data
  };
}, { updateProfile: _profile.update }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ChildProfile, _Component);

  function ChildProfile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ChildProfile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChildProfile.__proto__ || (0, _getPrototypeOf2.default)(ChildProfile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      childName: _this.props.profile.childName || '',
      childDOB: _this.props.profile.childDOB || '',
      childGender: _this.props.profile.childGender || '',
      isEdit: false
    }, _this.handleClickEdit = function () {
      var obj = _this.state;
      obj.isEdit = !obj.isEdit;
      _this.setState(obj);
    }, _this.handleDOBChange = function (value) {
      _this.setState({
        childDOB: value
      });
    }, _this.handleChange = function (str, event) {
      var obj = {};
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleSave = function () {
      var userId = _this.props.user.userId;
      _this.props.updateProfile(userId, _this.state);
    }, _this.formatchildDOB = function () {
      var date = new Date(_this.props.profile.childDOB);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var dt = date.getDate();

      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }

      return dt + '/' + month + '/' + year;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* ****************************** */
  /* HANDLE FORM CHANGE FUNCTIONS   */
  /* ****************************** */

  // without handleChange, form value fields would not change on the front end


  // prints out the formatted child date of birth on front end


  (0, _createClass3.default)(ChildProfile, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /* Editing gender doesn't work right now, because in Profile.js we aren't changing the redux store,
      only changing the state, which is obviously useless, I hope future me remembers why */
      var styles = require('./Profile.scss');

      return _react2.default.createElement(
        'div',
        null,
        !this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card },
            _react2.default.createElement(
              'div',
              { className: styles.cardContent },
              _react2.default.createElement(
                'h2',
                { className: styles.orangeText + ' ' + styles.textCenter },
                'Child profile'
              ),
              _react2.default.createElement(
                'h4',
                { className: styles.greenText },
                'Name: ',
                _react2.default.createElement(
                  'span',
                  { className: styles.normalText },
                  this.state.childName
                )
              ),
              _react2.default.createElement(
                'h4',
                { className: styles.greenText },
                'Date of birth: ',
                _react2.default.createElement(
                  'span',
                  { className: styles.normalText },
                  this.formatchildDOB()
                )
              ),
              _react2.default.createElement(
                'h4',
                { className: styles.greenText },
                'Gender: ',
                _react2.default.createElement(
                  'span',
                  { className: styles.normalText },
                  this.state.childGender
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.ButtonToolbar,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { className: 'pull-right',
                    bsStyle: 'success', onClick: this.handleClickEdit },
                  _react2.default.createElement('i', { className: 'fa fa-user-o' }),
                  '  Edit profile'
                )
              )
            )
          )
        ),
        this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card + ' ' + styles.cardContent },
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'Child profile'
            ),
            _react2.default.createElement(
              ReactBootstrap.Form,
              { horizontal: true },
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 3 },
                  _react2.default.createElement(
                    ReactBootstrap.ControlLabel,
                    null,
                    'Name:'
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 9 },
                  _react2.default.createElement(ReactBootstrap.FormControl, {
                    type: 'text',
                    placeholder: 'First name',
                    value: this.state.childName,
                    onChange: this.handleChange.bind(this, 'childName') })
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 3 },
                  _react2.default.createElement(
                    ReactBootstrap.ControlLabel,
                    null,
                    'Date of birth:'
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 9 },
                  _react2.default.createElement(DatePicker, { id: 'childDOB', value: this.state.childDOB, onChange: this.handleDOBChange, dateFormat: 'DD/MM/YYYY' })
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'childGender') },
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 3 },
                  _react2.default.createElement(
                    ReactBootstrap.ControlLabel,
                    null,
                    'Gender:'
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 9 },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { inline: true, name: 'childGender', value: 'Male', defaultChecked: this.state.childGender === 'Male' },
                    'Male'
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { inline: true, name: 'childGender', value: 'Female', defaultChecked: this.state.childGender === 'Female' },
                    'Female'
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { inline: true, name: 'childGender', value: 'Other', defaultChecked: this.state.childGender === 'Other' },
                    'Other'
                  )
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.ButtonToolbar,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { bsStyle: 'success', className: 'pull-right', onClick: function onClick() {
                    _this2.handleClickEdit();_this2.handleSave();
                  } },
                _react2.default.createElement('i', { className: 'fa fa-check' }),
                '  Save'
              )
            )
          )
        )
      );
    }
  }]);
  return ChildProfile;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateProfile: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = ChildProfile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/ChildProfile.js
// module id = 1222
// module chunks = 0